module.exports = __webpack_public_path__ + "static/img/weather_042.7fc10239.svg";